import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateColumnsDefinition
 */

type Props = {
  handleActionEditAccessGroup: (id: number | undefined) => void,
  handleActionDeleteAccessGroup: (id: number | undefined) => void,
};

export const GenerateColumnsDefinition = ({
  handleActionEditAccessGroup,
  handleActionDeleteAccessGroup,
}: Props): GridColDef[] => {
  return [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      flex: 0,
      minWidth: 50,
      sortable: false,
      headerClassName: 'usuarios-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center" >
          <ItemStatus
            size="autowidth"
            title={params.value === true ? "Ativo" : "Bloqueado"}
            color={params.value === true ? "green" : "red"}
            description={params.value === true ? "Grupo Ativo" : "Grupo Bloqueado"} />
        </div>
      ),
    },
    {
      field: "nomeGrupo",
      filterable: false,
      headerName: "Nome",
      flex: 1,
      minWidth: 100,
      sortable: false,
      headerClassName: 'usuarios-header',
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 100,
      sortable: false,
      headerClassName: 'usuarios-header',
    },
    {
      field: 'idGrupoAcesso',
      headerName: 'Ações',
      flex: 0,
      minWidth: 120,
      sortable: false,
      filterable: false,
      headerClassName: 'usuarios-header',
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2" >
            <IconButton onClick={() => handleActionEditAccessGroup(params.value)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>
            < IconButton
              onClick={() => handleActionDeleteAccessGroup(params.value)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        )
      },
    }
  ];
}